import React from "react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { formInputInfo } from "../../types/types";
import FormInput from "../form/FormInput";
import { FormSelect } from "../form/FormSelect";

interface DependencyModalProps {
  styles?: string;
  modalId: string;
  item: formInputInfo;
  options: { id: string; name: string }[];
  amountOptions: { id: string; name: string }[];
  modalAction: (item: formInputInfo, modalId: string) => void;
  modalCancel: (modalId: string) => void;
}

export const DependencyModal: React.FC<DependencyModalProps> = ({
  styles,
  modalId,
  item,
  options,
  amountOptions,
  modalAction,
  modalCancel,
}) => {
  const [state, setState] = useState({
    ...item,
    repeatable: item.repeatable
      ? {
          key: findValue(item.repeatable.key),
          after: findValue(item.repeatable.after),
          value: item.repeatable.value,
          amount: findValue(item.repeatable.amount) || item.repeatable.amount,
          header: item.repeatable.header,
        }
      : {
          key: "",
          after: "",
          amount: "",
          value: "",
          header: "",
        },
  });
  const style =
    styles !== undefined ? styles : "text-center shadow-xl overflow-y scroller";
  const optionsName = [""].concat(
    options.map((item) => `${item.name}::${item.id}`)
  );
  const amountOptionsName: string[] = [""].concat(
    amountOptions.map((item) => `${item.name}::${item.id}`)
  );

  const localInputChange = (e: any) => {
    setState({
      ...state,
      repeatable: {
        ...state.repeatable,
        [e.target.id]: e.target.value,
      },
    });
  };

  function findValue(key: string) {
    const item = options.find((item) => item.id === key);
    return item !== undefined ? `${item.name}::${item.id}` : "";
  }

  function findId(key: string) {
    const id = key.split("::")[1];
    const item = options.find((item) => item.id === id);
    return item !== undefined ? item.id : "";
  }

  //TODO: intenationalisaatiot/käännökset input kenttien question attribuuteille!

  return (
    <div className={style}>
      <div className='flex flex-col'>
        <div className='flex flex-col'>
          <p className='uppercase font-semibold m-4 text-brand-dark_blue'>
            Onko tämä toistettava kysymys?
          </p>
          <p className='m-4 text-brand-dark_blue'>
            Mikäli haluat toistaa tämän kysymyksen (esim. per osallistuja)
          </p>
          <p className='m-4 text-brand-dark_blue'>
            Voit myös määritellä useita kysymyksiä samoilla ehdoilla, niin ne
            muodostavat toistoryhmän.
          </p>
          <FormSelect
            id='key'
            question='key'
            options={optionsName}
            value={state.repeatable.key}
            handleInputChange={localInputChange}
            cursiveLabel='Valitse kysymys, jota seurataan'
          />
          <FormInput
            id='value'
            question='value'
            value={state.repeatable.value}
            type='text'
            handleInputChange={localInputChange}
            cursiveLabel='Syötä arvo, jonka seurattavan kysymyksen täytyy saada'
          />
          <FormSelect
            id='amount'
            question='amount'
            options={amountOptionsName}
            value={state.repeatable.amount}
            handleInputChange={localInputChange}
            cursiveLabel='Valitse kysymys, jonka perusteella saadaan toistojen määrä (vain numerokysymykset mahdollisia).'
          />
          <FormSelect
            id='after'
            question='after'
            options={optionsName}
            value={state.repeatable.after}
            handleInputChange={localInputChange}
            cursiveLabel='Valitse kysymys, jonka jälkeen toisto tehdään. Huom! Jos sivulla on useita kysymysryhmiä, toistettavat kysymykset tulevat viimeisen ryhmän jälkeen.'
          />
          <FormInput
            id='header'
            question='header'
            value={state.repeatable.header}
            type='text'
            handleInputChange={localInputChange}
            cursiveLabel='Toistoryhmän otsikko'
          />
        </div>
        <div className='flex flex-row justify-around'>
          <div className='pb-6'>
            <button
              onClick={() =>
                modalAction(
                  {
                    ...state,
                    repeatable: {
                      key: findId(state.repeatable.key),
                      value: state.repeatable.value,
                      amount: findId(state.repeatable.amount),
                      after: findId(state.repeatable.after),
                      header: state.repeatable.header,
                    },
                  },
                  modalId
                )
              }
              className='bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-20 h-10'
            >
              <FormattedMessage id='AlertDialog.confirm_button' />
            </button>
          </div>
          <div className='pb-6'>
            <button
              onClick={() =>
                modalAction(
                  {
                    ...state,
                    repeatable: {
                      key: "",
                      value: "",
                      amount: "",
                      after: "",
                      header: "",
                    },
                  },
                  modalId
                )
              }
              className='bg-red-300 hover:bg-red-400 text-brand-white m-4 rounded w-20 h-10'
            >
              Poista piilotus
            </button>
          </div>
          <div className='pb-6'>
            <button
              onClick={() => modalCancel(modalId)}
              className='bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-20 h-10'
            >
              <FormattedMessage id='AlertDialog.cancel_button' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DependencyModal;
